let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1Uxg1")).then(() => parcelRequire('fAWMX'));